<div class="di-choix-level-debug-sce">
	<div class="dialog-content">
		<form [formGroup]="ordoDebug"  class="form-ordo-debug">
			<div class="level-selection">
				<lua-select 
					formControlName="debugLevel"
					[options]="debugLevels" 
					placeholder="Choisir le niveau de debug">
				</lua-select>
			</div>
			<lua-action-secondaire [libelle]="'Confirmer'" [color]="'CouleurPrimaire'" [fullWidth]="true"
				[avecIcone]="false" [size]="'medium'" [isDisabled]="false" [positionIcone]="'L'"
				(click)="handleOnConfirm()"></lua-action-secondaire>
			<lua-bouton-texte [libelle]="'Annuler'" [color]="'CouleurPrimaire'" [fullWidth]="true" [isDisabled]="false"
				[endIcon]="''" [type]="'button'" [size]="'medium'" (click)="handleOnCancel()"></lua-bouton-texte>
		</form>
	</div>
</div>